export const BuildInfo = {timestamp:1779401079000}
